import { Helmet } from "react-helmet";

import MainSlider from "./snippets/MainSlider";
import MasterGamesList from "./data/MasterGamesList";
import PromotionsList from "./snippets/PromotionsList";
import LandingPageSelection from "./snippets/LandingPageGamesSelection";
import ProvidersData from "./data/ProvidersData";

export const currentPath = window.location.pathname;
export const currentDomain = window.location.origin;

export default function Index() {
	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>FGH - Your One-Stop Gaming Site</title>
				<link rel="icon" href="/images/fav.webp" sizes="32x32" />
				<meta
					name="description"
					content="Fun Gaming Hub – your trusted Filipino online casino. Play live blackjack, slot games, and sports betting using GCash or Maya. Safe, fast, and for players 21+."
				/>
				<link rel="canonical" href={`${currentDomain}${currentPath}`} />
			</Helmet>
			<section className="main-body-content main-container-global-adjusted-padding">
				<MainSlider />
				<div className="fgh-section-margin fgh-home-top-games">
					<div className="fgh-section-margin fgh-home-provider-games">
						<ProvidersData />
					</div>
					<MasterGamesList
						limit={6}
						recentgames="all"
						headerTag="h1"
						headerText="Play your Recent Games"
					/>
				</div>

				{/* <div className="fgh-section-margin fgh-home-top-games">
          <MasterGamesList
            topGames="on"
            rank="on"
            limit={6}
            linkTo="/slots/?=top-games"
            headerText="Top Games Today - Play Now"
            headerTag="h2"
          />
        </div> */}
				<div className="fgh-section-margin fgh-home-top-games">
					<MasterGamesList
						featuredGamesOnly="on"
						rank="on"
						topGamesRtp="on"
						customFeaturedGames={[
							{
								provider: "jili",
								gameName: "Super Ace",
							},
							{
								provider: "jili",
								gameName: "Fortune Garuda 500",
							},
							{
								provider: "fastspin",
								gameName: "Royale House",
								rtpTag: "96.45%",
							},
							{
								provider: "fastspin",
								gameName: "Mahjong Princess",
								rtpTag: "96.61%",
							},
							{
								provider: "vp",
								gameName: "Golden Mahjong",
								rtpTag: "96.41%",
							},
							{
								provider: "vp",
								gameName: "Super Crown",
								rtpTag: "96.49%",
							},
						]}
						limit={6}
						linkTo="/slots/?=top-games"
						headerText="Top Games Today - Play Now"
						headerTag="h2"
					/>
				</div>
				<div className="fgh-section-margin fgh-home-promo">
					<PromotionsList />
				</div>
				<div className="fgh-section-margin fgh-home-top-games">
					<MasterGamesList limit={6} recentgames="1" headerTag="h2" />
				</div>
				<div className="fgh-section-margin fgh-home-top-games">
					<MasterGamesList limit={6} recentgames="2" headerTag="h2" />
				</div>
				<div className="fgh-section-margin fgh-home-selection-games">
					<LandingPageSelection />
				</div>
				<div className="fgh-section-margin fgh-home-top-games">
					<MasterGamesList
						limit={6}
						recentgames="3"
						linkTo="/slots"
						headerTag="h2"
					/>
				</div>
				<div className="fgh-section-margin fgh-home-top-games">
					{/* <MasterGamesList
            limit={4}
            livegames="on"
            linkTo="/slots"
            headerText="Now Live: Yellowbat Slots"
            subtext=""
            headerTag="h2"
          /> */}
					<MasterGamesList
						qualifiedGamesOnly="on"
						customQualifiedGames={[
							{
								provider: "cq9",
								gameName: "Sweet POP",
								rtpTag: "96.15%",
							},
							{
								provider: "cq9",
								gameName: "Football Fever M",
								rtpTag: "96.08%",
							},
							{
								provider: "cq9",
								gameName: "Greek Gods",
								rtpTag: "96.09%",
							},
							{
								provider: "cq9",
								gameName: "Treasure Pirate",
								rtpTag: "96.12%",
							},
							{
								provider: "cq9",
								gameName: "Floating Market",
								rtpTag: "96.15%",
							},
							{
								provider: "cq9",
								gameName: "888 Cai Shen",
								rtpTag: "96.14%",
							},
						]}
						limit={6}
						headerText="High Volatility CQ9 Slots"
						linkTo="/slots/?provider=CQ9"
						headerTag="h2"
					/>
				</div>

				<div className="fgh-section-margin fgh-section-articles">
					<div className="fgh-main-page-content">
						<div className="fgh-left-char">
							<img src="/images/character/FGH-CHARACTER_1.webp?v=1" alt="" />
						</div>
						<div className="fgh-right-cont">
							<h2 className="fgh-h2-style standard-margin-bottom">
								FGH – Best Casino Site, Just for You
							</h2>
							<p className="fgh-paragraph-standard-style">
								Get ready to spin, win, and have a blast! At FGH, we bring you a
								thrilling collection of online slots designed to keep the
								excitement rolling. Whether you're here for big wins, fun
								themes, or just some good old-fashioned luck, we’ve got
								something for everyone. No complicated rules, just pure
								entertainment at your fingertips!
							</p>
							<p className="fgh-paragraph-standard-style">
								So, why wait? Dive into the action, explore our wide range of
								slots, and let the reels do the talking. Who knows? Your next
								spin could be the lucky one!{" "}
							</p>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}
